module.exports = __webpack_public_path__ + "assets/img/customerService.e6fce231.png";